module.exports = __webpack_public_path__ + "static/img/Rectangle_806@2x.4987eb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/Rectangle_806@2x.png
// module id = krak
// module chunks = 59